import React from 'react';
import { PartyFormModal } from '../PartyFormModal';
import { BrokerFormModal } from '../BrokerFormModal';

export function PartyQuickCreateModal({ open, onClose, onCreated }) {
  return (
    <PartyFormModal
      open={open}
      onClose={onClose}
      mode="create"
      partyCategory="PARTIES"
      modalTitle="Add Party"
      namePlaceholder="Party name"
      onSaved={onCreated}
      formId="order-quick-party-form"
    />
  );
}

export function BrokerQuickCreateModal({ open, onClose, onCreated }) {
  return (
    <BrokerFormModal
      open={open}
      onClose={onClose}
      mode="create"
      onSaved={onCreated}
      formId="order-quick-broker-form"
    />
  );
}

export function TransportQuickCreateModal({ open, onClose, onCreated }) {
  return (
    <PartyFormModal
      open={open}
      onClose={onClose}
      mode="create"
      partyCategory="TRANSPORT_PARTIES"
      modalTitle="Add transport party"
      namePlaceholder="Transport / transporter name"
      onSaved={onCreated}
      formId="order-quick-transport-form"
    />
  );
}
